export const cleanBackslash = (str: string) => str.replace(/\\/g, '')
